import React from 'react';

function ThemeSuspense() {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        background: 'var(--invex-bg)',
      }}
    >
      <div style={{ textAlign: 'center' }}>
        <div
          style={{
            fontFamily: "'Rajdhani', sans-serif",
            fontSize: 32,
            fontWeight: 700,
            color: 'var(--invex-teal)',
            letterSpacing: 4,
            marginBottom: 20,
          }}
        >
          Altharo
        </div>
        <div className="invex-spinner" style={{ margin: '0 auto' }} />
      </div>
    </div>
  );
}

export default ThemeSuspense;
